
import createIcon from "./createIcon";

export const Clock3Icon = createIcon('Clock3', (props) => {
  return (
    <svg {...props}>
      <g>
        <path id="path" d="M14 7.99C14 11.31 11.31 13.99 8 13.99L8 15.33C12.05 15.33 15.33 12.04 15.33 7.99L14 7.99ZM8 13.99C4.68 13.99 2 11.31 2 7.99L0.66 7.99C0.66 12.04 3.95 15.33 8 15.33L8 13.99ZM2 7.99C2 4.68 4.68 1.99 8 1.99L8 0.66C3.95 0.66 0.66 3.94 0.66 7.99L2 7.99ZM8 1.99C11.31 1.99 14 4.68 14 7.99L15.33 7.99C15.33 3.94 12.05 0.66 8 0.66L8 1.99Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
        <path id="path" d="M7.33 8.67C7.33 9.04 7.63 9.33 7.99 9.33C9.5 9.33 8.34 9.26 8.47 9.14C8.59 9.02 8.66 8.85 8.66 8.67L7.33 8.67ZM8.66 4.33C8.66 3.97 8.36 3.67 7.99 3.67C7.63 3.67 7.33 3.97 7.33 4.33L8.66 4.33ZM8.66 8.67L8.66 4.33L7.33 4.33L7.33 8.67L8.66 8.67Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
        <path id="path" d="M8.16 7.99C7.79 7.99 7.49 8.29 7.49 8.66C7.49 9.03 7.79 9.33 8.16 9.33L8.16 7.99ZM10.66 9.33C11.03 9.33 11.33 9.03 11.33 8.66C11.33 8.29 11.03 8 10.66 8L10.66 9.33ZM8.16 9.33L10.66 9.33L10.66 8L8.16 7.99L8.16 9.33Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
      </g>
    </svg >
  )
});
